import {
  Autocomplete,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  TextField,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import {
  buscarRelatoriosPorCodigo,
  exportarRelatorio,
} from "../../services/api-relatorios.service";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./styles.module.css";
import { buscarComboPorCodigo } from "../../services/auth.service";
import MensagemErro from "../MensagemErro";
import MensagemSucesso from "../MensagemSucesso";
import GenericDatePicker from "../GenericDatePicker";
import BtnOptionExport from "./btnOptionExport";
import DescriptionIcon from "@mui/icons-material/Description";
import ContasContabeis from "./ContasContabeis";
import NovoExportador from "./NovoExportador";
import Loading from "../Loading";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const styleButton = {
  border: "1px solid #18316E",
  borderRadius: "20px",
  color: "#18316E",
  "&:hover": {
    backgroundColor: "#d0daf5",
  },
};

const BotaoRelatorio = ({ label, codigoRelatorio }) => {
  const [openModal, setOpenModal] = useState(false);
  const [dadosRelatorio, setDadosRelatorio] = useState({
    nome: "",
    colunas: [],
    filtros: [],
  });
  const [filtros, setFiltros] = useState([]);
  const [colunas, setColunas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [comboOptions, setComboOptions] = useState({});
  const [hasSchema, setHasSchema] = useState(false);
  const [listaGruposEconomicos, setListaGruposEconomicos] = useState([]);
  const [grupoSelecionado, setGrupoSelecionado] = useState(null);
  const [schemas, setSchemas] = useState([]);
  const [schemasSelected, setSchemasSelected] = useState([]);
  const [msg, setMsg] = useState("");
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [dadosPai, setDadosPai] = useState({});
  const [comboFilho, setComboFilho] = useState({});
  const [typeData, setTypeData] = useState("csv");

  const handleResetTypeData = () => {
    setTypeData("csv");
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await buscarRelatoriosPorCodigo(codigoRelatorio);
        setDadosRelatorio(response.relatorios[0]);
        const searchSchema =
          response.relatorios[0].script.includes("${schema}");
        if (searchSchema) {
          const listaGrupos = await handleRenderListAutoComplete(
            "GRUPOECONOMICO"
          );
          setListaGruposEconomicos(listaGrupos);
          setHasSchema(true);
        }
      } catch (error) {
        console.log(error);
      }
    };
    if (openModal) fetch();
  }, [openModal, codigoRelatorio]);

  useEffect(() => {
    const fetchData = async () => {
      const empresas = await handleRenderListAutoComplete(
        `EMPRESA_POR_GRUPO_${grupoSelecionado?.id}`
      );
      setSchemas(empresas);
    };
    grupoSelecionado ? fetchData() : setSchemas([]);
  }, [grupoSelecionado]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setFiltros([]);
    setColunas([]);
    setSchemas([]);
    setDadosPai({});
    setComboOptions({});
    setComboFilho({});
    setGrupoSelecionado(null);
    setSchemasSelected([]);
    setTypeData("csv");
    setOpenModal(false);
  };

  const handleColunaChange = (_, newValue) => {
    if (newValue.some((option) => option.variavel === "select_all")) {
      const allSelected = colunas.length === dadosRelatorio.colunas.length;
      setColunas(allSelected ? [] : dadosRelatorio.colunas);
    } else {
      setColunas(newValue);
    }
  };

  const handleFiltroChange = (_, newValue) => {
    if (newValue.some((option) => option.variavel === "select_all")) {
      const allSelected = filtros.length === dadosRelatorio.filtros.length;
      setFiltros(
        allSelected
          ? []
          : dadosRelatorio.filtros.map((option) => {
              const parametro = option.script?.match(/\$P\{[^}]*\}/g) || [];
              return {
                ...option,
                valor: "",
                parametro: parametro[0] || "",
              };
            })
      );
    } else {
      setFiltros(newValue);
    }
  };

  const handleAutoCompletePai = (codCombo, value) => {
    if (value) {
      setDadosPai({ ...dadosPai, [codCombo]: value });
    } else {
      const { [codCombo]: _, ...resto } = dadosPai;
      setDadosPai(resto);
    }
  };

  const handleAutocompleteChange = (variavel, value, codCombo) => {
    const selectAllOption = value.some(
      (item) => item.detalhes === "Selecionar todos"
    );

    const valorAtual = filtros
      .find((item) => item.codCombo === codCombo)
      ?.valor?.split(",");
    const allSelected = valorAtual?.length === comboFilho[codCombo]?.length - 1;

    const newValue = () => {
      if (selectAllOption) {
        const withoutSelectAll = value.filter(
          (item) => item.id !== "select_all"
        );
        if (allSelected && withoutSelectAll.length === 0) {
          return "";
        }

        if (withoutSelectAll.length > 0) {
          const resultado = valorAtual?.filter(
            (item) => !withoutSelectAll?.some((obj) => item?.includes(obj?.id))
          );
          return resultado.map((item) => `${item}`).join(",");
        } else {
          return comboFilho[codCombo]
            .filter((item) => item.detalhes !== "Selecionar todos")
            .map((item) => `'${item.id}'`)
            .join(", ");
        }
      } else {
        return value.map((item) => `'${item.id}'`).join(", ");
      }
    };
    setFiltros((prevFiltros) =>
      prevFiltros.map((option) =>
        option.variavel === variavel ? { ...option, valor: newValue() } : option
      )
    );
  };

  const handleInputChange = (variavel, valor) => {
    setFiltros((prevFiltros) =>
      prevFiltros.map((option) =>
        option.variavel === variavel ? { ...option, valor } : option
      )
    );
  };

  const handleRenderListAutoComplete = async (codCombo) => {
    const response = await buscarComboPorCodigo(codCombo);
    const combosFormat = response.detalhes.itensCombo
      .filter((item) => item)
      .map((item) => {
        const split = item.split("/|/");
        return {
          id: split[0],
          detalhes: split[1],
        };
      });

    return combosFormat;
  };

  const handleChangeSchema = (value) => {
    if (value.some((option) => option.id === "select_all")) {
      const allSelected = schemas.length === schemasSelected.length;
      setSchemasSelected(allSelected ? [] : schemas);
    } else {
      setSchemasSelected(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const newComboOptions = {};
      for (const option of filtros) {
        if (option.tipoDado === "autocomplete") {
          const combosFormat = await handleRenderListAutoComplete(
            option.codCombo
          );
          newComboOptions[option.codCombo] = combosFormat;
        }
        if (option.tipoDado === "autocomplete_dependencia") {
          const combosFormatPai = await handleRenderListAutoComplete(
            option.codComboPai
          );
          newComboOptions[option.codComboPai] = combosFormatPai;
        }
      }

      setComboOptions(newComboOptions);
    };
    fetchData();
  }, [filtros]);

  const handleNameTextField = (variavel) => {
    const find = dadosRelatorio.filtros.find(
      (item) => item.variavel === variavel
    );
    return find?.nome || "";
  };

  const handleSubmit = async () => {
    setLoading(true);
    let newSchemas = null;
    if (hasSchema) {
      newSchemas = schemasSelected.map((item) => {
        return `z_${item.id}`;
      });
    }

    const newFiltros =
      filtros.length > 0
        ? filtros.map((item) => {
            // Encontrar todos os parâmetros no script do filtro
            const parametros = item.script?.match(/\$P\{[^}]*\}/g) || [];

            // Gerar valores correspondentes para cada parâmetro (ajuste conforme necessário)
            const valores = parametros.map((param) => {
              const findFiltro = filtros
                .filter((item) => item.script.includes(param))
                .map((filtro) => {
                  return filtro.valor;
                });

              return findFiltro;
            });
            return {
              ...item,
              parametros, // Array de parâmetros
              valores: valores[0], // Array de valores correspondentes
            };
          })
        : null;

    const body = {
      idRelatorio: dadosRelatorio.idRelatorio,
      colunas: colunas.length > 0 ? colunas : null,
      filtros: newFiltros,
      schemas: newSchemas,
    };

    try {
      const response = await exportarRelatorio(body, typeData);
      
      switch (typeData) {
        case "csv":
        case "excel":
          if (response.size) {
            const blob = new Blob([response], {
              type: "text/csv;charset=utf-8",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${dadosRelatorio.nome}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            setMsg("Relatório gerado com sucesso!");
            handleOpenSnackbarSucesso();
          } else {
            throw new Error(response.mensagem);
          }

          break;
        case "PDF":
          if (response.arquivoPdf) {
            const buffer = new Uint8Array(response.arquivoPdf.data);
            const pdfBlob = new Blob([buffer], {
              type: "application/octet-stream",
            });

            const pdfUrl = window.URL.createObjectURL(pdfBlob);
            const linkDownloadPdf = document.createElement("a");

            linkDownloadPdf.href = pdfUrl;
            linkDownloadPdf.setAttribute(
              "download",
              `${dadosRelatorio.nome}.pdf`
            );

            document.body.appendChild(linkDownloadPdf);
            linkDownloadPdf.click();
            document.body.removeChild(linkDownloadPdf);
            window.URL.revokeObjectURL(pdfUrl);

            setMsg("Relatório gerado com sucesso!");
            handleOpenSnackbarSucesso();
          } else {
            throw new Error(response.mensagem);
          }

          break;

        case "AMBOS":
          console.log(response);

          if (response) {
            const blob = new Blob([response], {
              type: "application/zip",
            });

            const url = window.URL.createObjectURL(blob);
            console.log(url);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `${dadosRelatorio.nome.replace(/\./g, "")}.zip`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            setMsg("Relatório gerado com sucesso!");
            handleOpenSnackbarSucesso();
          } else {
            throw new Error(response.mensagem);
          }
          break;
      }

      handleCloseModal();
      handleResetTypeData();
    } catch (error) {
      setGrupoSelecionado(null);
      setSchemasSelected([]);
      setMsg(`Temos um erro: ${error}`);
      handleOpenSnackbarErro();
      handleResetTypeData();
    } finally {
      setLoading(false);
    }
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };
  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };
  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };
  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleTypeData = (type) => {
    setTypeData(type);
  };

  const handleComboFilho = (dadosComboPai, codCombo, option) => {
    if (!comboFilho[codCombo]) {
      if (dadosComboPai) {
        try {
          handleRenderListAutoComplete(codCombo + dadosComboPai?.detalhes)
            .then((item) => {
              setComboFilho((prevComboFilho) => ({
                ...prevComboFilho,
                [codCombo]: [
                  { id: "select_all", detalhes: "Selecionar todos" },
                  ...item,
                ],
              }));
              setComboOptions((prevComboFilho) => ({
                ...prevComboFilho,
                [codCombo]: [
                  { id: "select_all", detalhes: "Selecionar todos" },
                  ...item,
                ],
              }));
            })
            .catch((error) => {
              if (error.response.data.erro.includes("não existe a relação")) {
                setMsg("Valor não encontrado!");
                handleOpenSnackbarErro();
              } else {
                setMsg(error.response.data.mensagem);
                handleOpenSnackbarErro();
              }
            });
        } catch (error) {
          setMsg(error.response.data.mensagem);
          handleOpenSnackbarErro();
        }
      }
    }

    const acharChecked = (option) => {
      const verificacao = filtros
        .find((item) => item.codCombo === codCombo)
        ?.valor?.split(",")
        .some((elemento) => elemento.trim().replace(/'/g, "") === option.id);
      return verificacao ?? false;
    };

    return (
      <Autocomplete
        multiple
        options={codCombo in comboFilho ? comboFilho[codCombo] : []}
        disableCloseOnSelect
        getOptionLabel={(option) => option.detalhes}
        noOptionsText="Não possuem opções para o valor selecionado"
        isOptionEqualToValue={(option, value) => option.id === value.id}
        sx={{ marginTop: "1rem", width: "100%" }}
        // renderOption={(props, option, { selected }) => {
        //   const { key, ...optionProps } = props;
        //   return (
        //     <li key={key} {...optionProps}>
        //       <Checkbox
        //         icon={icon}
        //         checkedIcon={checkedIcon}
        //         style={{ marginRight: 8 }}
        //         checked={acharChecked(option)}
        //       />
        //       {option.detalhes}
        //     </li>
        //   );
        // }}
        onChange={(_, value) =>
          handleAutocompleteChange(option.variavel, value, option.codCombo)
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={`Valor para ${handleNameTextField(option.variavel)}`}
          />
        )}
      />
    );
  };

  return (
    <>
      <Button
        startIcon={<DescriptionIcon />}
        sx={styleButton}
        onClick={handleOpenModal}
      >
        {label ?? "Relatório"}
      </Button>
      <Dialog
        open={openModal}
        maxWidth={loading ? null : "md"}
        fullWidth={loading ? false : true}
        onClose={handleCloseModal}
      >
        <DialogContent>
          {loading ? (
            <Loading loading={loading}/>
          ) : (
            <>
              <div>
                <h2>{dadosRelatorio?.nome}</h2>
                <NovoExportador label={label} codRelatorio={codigoRelatorio}/>
              </div>
              <br />
              <Autocomplete
                fullWidth
                multiple
                options={[
                  { nome: "Selecionar todos", variavel: "select_all" },
                  ...dadosRelatorio.colunas,
                ]}
                disableCloseOnSelect
                getOptionLabel={(option) => option.nome}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={
                          selected ||
                          (option.variavel === "select_all"
                            ? colunas.length === dadosRelatorio.colunas.length
                            : colunas.some(
                                (coluna) => coluna.variavel === option.variavel
                              ))
                        }
                      />
                      {option.nome}
                    </li>
                  );
                }}
                value={
                  colunas.length === dadosRelatorio.colunas.length
                    ? [{ nome: "Selecionar todos", variavel: "select_all" }]
                    : colunas
                }
                onChange={handleColunaChange}
                renderInput={(params) => (
                  <TextField {...params} label="Colunas" />
                )}
              />
              <br />
              <Autocomplete
                multiple
                options={[
                  { nome: "Selecionar todos", variavel: "select_all" },
                  ...dadosRelatorio.filtros,
                ]}
                disableCloseOnSelect
                getOptionLabel={(option) => option.nome}
                isOptionEqualToValue={(option, value) =>
                  option.variavel === value.variavel
                }
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={
                          selected ||
                          (option.variavel === "select_all"
                            ? filtros.length === dadosRelatorio.filtros.length
                            : filtros.some(
                                (filtro) => filtro.variavel === option.variavel
                              ))
                        }
                      />
                      {option.nome}
                    </li>
                  );
                }}
                value={
                  filtros.length === dadosRelatorio.filtros.length
                    ? [{ nome: "Selecionar todos", variavel: "select_all" }]
                    : filtros
                }
                onChange={handleFiltroChange}
                renderInput={(params) => (
                  <TextField {...params} label="Filtros" />
                )}
              />
              {hasSchema ? (
                <>
                  <Autocomplete
                    options={listaGruposEconomicos || []}
                    getOptionLabel={(option) => option.detalhes}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    sx={{ marginTop: "1rem", width: "100%" }}
                    // renderOption={(props, option, { selected }) => {
                    //   const { key, ...optionProps } = props;
                    //   return (
                    //     <li key={key} {...optionProps}>
                    //       <Checkbox
                    //         icon={icon}
                    //         checkedIcon={checkedIcon}
                    //         style={{ marginRight: 8 }}
                    //         checked={selected}
                    //       />
                    //       {option.detalhes}
                    //     </li>
                    //   );
                    // }}
                    onChange={(_, value) => setGrupoSelecionado(value)}
                    renderInput={(params) => (
                      <TextField {...params} label={`Grupo Economico`} />
                    )}
                  />
                  {schemas.length > 0 ? (
                    <Autocomplete
                      options={
                        [
                          { detalhes: "Selecionar todos", id: "select_all" },
                          ...schemas,
                        ] || []
                      }
                      multiple
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.detalhes}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      sx={{ marginTop: "1rem", width: "100%" }}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;
                        return (
                          <li key={key} {...optionProps}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={
                                selected ||
                                (option.id === "select_all"
                                  ? schemas.length === schemasSelected.length
                                  : schemasSelected.some(
                                      (coluna) => coluna.id === option.id
                                    ))
                              }
                            />
                            {option.detalhes}
                          </li>
                        );
                      }}
                      onChange={(_, value) => handleChangeSchema(value)}
                      renderInput={(params) => (
                        <TextField {...params} label={`Empresas`} />
                      )}
                    />
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
              {filtros.map((option) => (
                <Fragment key={option.codCombo}>
                  {option.tipoDado === "autocomplete" ? (
                    <Autocomplete
                      multiple
                      options={comboOptions[option.codCombo] || []}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.detalhes}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      sx={{ marginTop: "1rem", width: "100%" }}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;
                        return (
                          <li key={key} {...optionProps}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.detalhes}
                          </li>
                        );
                      }}
                      onChange={(_, value) =>
                        handleAutocompleteChange(
                          option.variavel,
                          value,
                          option.codCombo
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={`Valor para ${handleNameTextField(
                            option.variavel
                          )}`}
                        />
                      )}
                    />
                  ) : option.tipoDado === "data" ? (
                    <GenericDatePicker
                      key={option.variavel}
                      label={`Valor para ${handleNameTextField(
                        option.variavel
                      )}`}
                      value={option.valor}
                      onChange={(e) => handleInputChange(option.variavel, e)}
                      sx={{ marginTop: "1rem", width: "100%" }}
                    />
                  ) : option.nome === "Contas Contábeis" ? (
                    <ContasContabeis
                      schemas={schemasSelected}
                      setFiltros={setFiltros}
                    />
                  ) : (
                    <TextField
                      key={option.variavel}
                      label={`Valor para ${handleNameTextField(
                        option.variavel
                      )}`}
                      value={option.valor}
                      onChange={(e) =>
                        handleInputChange(option.variavel, e.target.value)
                      }
                      sx={{ marginTop: "1rem", width: "100%" }}
                    />
                  )}
                  {option.codComboPai in dadosPai
                    ? handleComboFilho(
                        dadosPai[option.codComboPai],
                        option.codCombo,
                        option
                      )
                    : ""}
                </Fragment>
              ))}
              <div className={styles.button_container}>
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<CloseIcon />}
                  onClick={handleCloseModal}
                >
                  Cancelar
                </Button>

                <BtnOptionExport
                  onClick={handleSubmit}
                  typeData={handleTypeData}
                  dadosRelatorio={dadosRelatorio}
                />
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </>
  );
};

export default BotaoRelatorio;
